import { FormControl as FC } from '@material-ui/core'
import styled from 'styled-components'

export const PaymentHelperText = styled.div`
  line-height: 1.2;
  margin-left: -14px;
  color: #0000008f;
  font-size: 12px;
  margin-top: 4px;
`
